module.exports = __webpack_public_path__ + "static/bed-builder-f5c386a6fa5a5aff5a18e9ecf9066367.png";